import { ApiHandlerDiscreteParameter, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { addExpediteShipping, ExpediteShippingParameter } from "@TKCCP/Services/tkccpExpediteShippingService";
import { ExpediteShippingModel } from "@TKCCP/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    HasOnSuccess & HasOnError<string>,
    ExpediteShippingParameter,
    ExpediteShippingModel,
    { expediteShippingModel: ExpediteShippingModel }
>;

export const AddExpediteShipping = (model: ExpediteShippingParameter) => {
    try {
        const result = addExpediteShipping(model);
        // eslint-disable-next-line no-empty
    } catch (error) {}
};
